import React, { createContext, useContext, useMemo, useReducer, useCallback } from 'react';
const ADD_ELEMENT = Symbol('ADD_ELEMENT');
const REMOVE_ELEMENT = Symbol('REMOVE_ELEMENT');
const reducer = (state, action) => {
  switch (action.type) {
    case ADD_ELEMENT:
      return [...state, action.payload];
    case REMOVE_ELEMENT:
      return state.filter(element => element.id !== action.payload);
    default:
      return state;
  }
};
export const SnackbarContext = /*#__PURE__*/createContext({
  state: [],
  dispatch: () => {},
  transitionProps: {}
});
export const SnackbarProvider = ({
  children,
  ...transitionProps
}) => {
  const [state, dispatch] = useReducer(reducer, []);
  const value = useMemo(() => ({
    state,
    dispatch,
    transitionProps
  }), [state, transitionProps]);
  return /*#__PURE__*/React.createElement(SnackbarContext.Provider, {
    value: value
  }, children);
};
export const useSnackbar = () => {
  const {
    state,
    dispatch
  } = useContext(SnackbarContext);
  const addSnack = useCallback(snack => dispatch({
    type: ADD_ELEMENT,
    payload: snack
  }), [dispatch]);
  const removeSnack = useCallback(id => dispatch({
    type: REMOVE_ELEMENT,
    payload: id
  }), [dispatch]);
  return {
    state,
    addSnack,
    removeSnack
  };
};